import axios from 'axios';

const http = axios.create({
  baseURL:
    process.env.NODE_ENV === 'production'
      ? '/lk'
      : 'http://localhost:8081/lk/',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  timeout: 180000
});

export default http;
